import { render, staticRenderFns } from "./CustomerCollectionChart.vue?vue&type=template&id=fc6d7a76&scoped=true"
import script from "./CustomerCollectionChart.vue?vue&type=script&lang=js"
export * from "./CustomerCollectionChart.vue?vue&type=script&lang=js"
import style0 from "./CustomerCollectionChart.vue?vue&type=style&index=0&id=fc6d7a76&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6d7a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc6d7a76')) {
      api.createRecord('fc6d7a76', component.options)
    } else {
      api.reload('fc6d7a76', component.options)
    }
    module.hot.accept("./CustomerCollectionChart.vue?vue&type=template&id=fc6d7a76&scoped=true", function () {
      api.rerender('fc6d7a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/endKanbanBoard/components/CustomerCollectionChart.vue"
export default component.exports